import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';

import { makeQueryString } from '../../util';

export type V = {
  '@id': string;
  '@type': 'Environment';
  id: string;
  slug: string;
  deployments: Array<{
    '@id': string;
    '@type': 'EnvironmentDeployment';
    id: string;
    name: string;
    url: string | null;
    visitorPassword: string | null;
    githubRepo: string | null;
    githubBranch: string | null;
    buildPlatform: string | null;
    latestBuild: {
      '@id': string;
      '@type': 'Build';
      id: string;
      release: {
        '@id': string;
        '@type': 'Release';
        id: string;
        versionNumber: string;
      };
      buildNumber: number;
      environment: string;
      platform: string | null;
      link: string;
      qaApprovedAt: string | null;
      expired: boolean;
      createdAt: string;
      buildEvents: Array<{
        '@id': string;
        '@type': 'BuildEvent';
        id: string;
        type: string;
        percent: number | null;
        recordedAt: string;
      }>;
    } | null;
    lastCommitTimestamp: string | null;
    lastCommitTitle: string | null;
    lastCommitAuthor: string | null;
    lastCommitHash: string | null;
    lastCommitCheckStatus: string | null;
  }>;
  accounts: Array<{
    '@id': string;
    '@type': 'EnvironmentAccount';
    id: string;
    type: string;
    username: string;
    password: string;
    instructions: string | null;
    isInternal: boolean;
  }>;
};

export type W_Create = {
  company: string;
  slug: string;
};

export type W_Update = {
  slug: string;
};

export function useReadCollectionListCompanySub(
  companyId: string,
  queryParams?: { page?: number },
  options?: ReadConfig
) {
  return useApiRead<HydraCollection<V>>(
    `/companies/${companyId}/environments${makeQueryString(queryParams)}`,
    options
  );
}

export function useReadItem(id: string, options?: ReadConfig) {
  return useApiRead<V>(`/environments/${id}`, options);
}
